import { gql } from "@apollo/client";

const GET_CATALOG = gql`
  query {
    getCatalog {
      data {
        catalog {
          title
          storeCatalogId
        }
      }
      status
      error
    }
  }
`;

export default GET_CATALOG;
